/* eslint-disable max-statements */
import { parse } from 'querystring';
import React from 'react';
import { useApolloClient } from '@apollo/client';
import { generateXtid, setXtidHeader } from '@catalogo/core-x-tid';
import { setCDNRegion } from '@catalogo/core-cdn-region';
import { useTestAB } from '@catalogo/core-experiments';
import { credentials } from '@catalogo/core-webpush';
import { useCookies } from '@catalogo/core-connect/cookies';
import { useConfig } from '@catalogo/core-connect/config';
import { useRouter } from '@catalogo/core-connect/router';
import { CustomStaticContext } from '@catalogo/core-pre-render/src/types';
import { PreRenderProps } from './types';
import { usePreRender } from './service';

const parseQs = (search = '') => parse(search?.replace('?', ''));

export const PreRender: React.FC<PreRenderProps> = ({ children }) => {
  const [allcookies, setCookie] = useCookies();
  const hasCep = !!allcookies?.persistentCep;
  const { staticContext, location } = useRouter();
  const qs = parseQs(location?.search);
  const client = useApolloClient();
  const config = useConfig();
  const { loading, data } = usePreRender({ skipSegments: false });
  // const override = hasCep ? 'out' : '';
  // const hasForceCepExperiment = useTestAB('EXP_CAT_DISC_PERSIST_CEP', override) === 'NEW';
  const hasForceCepExperiment = false;

  /* istanbul ignore next */
  if (!hasCep && hasForceCepExperiment) {
    setCookie('persistentCep', data?.region?.cep ?? '');
  }

  if (qs['rbid']) {
    setCookie('B2W-UID', qs['rbid']);
  }

  generateXtid(client);
  useTestAB('search-test-ab');
  useTestAB('buybox-test-ab');
  useTestAB('promocional-test-ab');
  useTestAB('CAT_ONSITE');

  if (staticContext) {
    setCDNRegion(staticContext as CustomStaticContext, data, config);
    setXtidHeader(client, staticContext as CustomStaticContext);
  }

  if (loading) {
    return null;
  }

  return <div {...credentials}>{children}</div>;
};

export default PreRender;
